

import AccountDelectionMainSection from "../PageElements/AccountDeletionPageElements/AccountDeletionMainSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";

export default function AccountDeletion() {
    return (
        <>

            <AccountDelectionMainSection/>
            <ConsultSection/>
            
        </>
    )
}